// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_online-task-inspection_thanks_thanks_module_ts":"c3bf5924a26c359c0404","src_app_error_forbidden_forbidden_module_ts":"5bbecd6233ff9f6c08d8","src_app_error_not-found_not-found_module_ts":"90bc71219dba66ada8b2"}[chunkId] + ".js";
};